<template>
	<div class="cnt-login">
		<br />
		<div class="group-login">
			<div class="login-logo">
				<img src="/static/logo.svg" class="logo" />
			</div>
			<div class="col-xs-4 col-xs-offset-4">
				<div class="box box-warning">
					<div class="box-header with-border">
						<h3 class="box-title">Seja bem vindo</h3>
					</div>
					<div class="box-body">
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-user"></i>
							</span>
							<input
								type="text"
								v-model="fLogin.login"
								placeholder="Usuário"
								class="form-control login"
							/>
						</div>
						<br />
						<div class="input-group">
							<span class="input-group-addon">
								<i class="fa fa-lock"></i>
							</span>
							<input
								type="password"
								v-model="fLogin.senha"
								@keyup.enter="login"
								placeholder="Senha"
								class="form-control pass"
							/>
						</div>
					</div>
					<div class="box-footer">
						<button
							type="button"
							class="btn btn-warning pull-right"
							@click="login"
						>
							<i class="fa fa-sign-in"></i>
							Entrar
						</button>
					</div>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import toastr from 'toastr';
	import WBS from 'js/http';

	export default {
		name: 'sistemLogin',
		data() {
			return {
				fLogin: {
					login: '',
					senha: '',
				},
			};
		},
		methods: {
			login() {
				if (this.fLogin.login == '') {
					toastr.warning('Entre com o email!');
					jQuery('.login').focus();
				} else if (this.fLogin.senha == '') {
					toastr.warning('Entre com a senha!');
					jQuery('.pass').focus();
				} else {
					WBS.send('public-custom-login', this.fLogin, (resp) => {
						if (resp.status == 'success') {
							toastr.success('Redirecionando...');
							console.log(resp.data.user.perfil.cod);
							// console.log(resp.data)
							this.$store.commit('LOGIN', resp.data);

							console.log('resp.data');
							console.log(resp.data.user.perfil);

							localStorage.setItem('test', true);

							this.$router.push(resp.data.user.perfil.start_page);

							console.log('this.$store');
							console.log(this.$store);
						} else {
							toastr.error(resp.msgs[0]);
						}
					});
				}
			},
		},
	};
</script>
<style scoped>
	.logo {
		width: 450px;
	}
	.cnt-login {
		width: 100vw;
		height: 100vh;
		display: block;
		/*background-image: url('/static/banner.png');*/
		background-size: cover;
		background-position: center;
		background-color: #d2d6de;
	}
	.group-login {
		margin-top: calc(50vh - 318.5px);
	}
</style>



// WEBPACK FOOTER //
// src/components/login/index.vue